module.exports = "/_next/static/images/jennifer-sands@3x-770a4eee22cf0203a1ad361e73678e77.png";